export default __webpack_public_path__ + "static/media/_DSC0939 (1).ebbd1976.jpg";